export const missionTypes = {
  UP_GET_MISSION_LOCK_STATUS: 'UP_MISSION_GET_MISSION_LOCK_STATUS',
  UP_MISSION_FETCH_SESSIONS: 'UP_MISSION_FETCH_SESSIONS',
  UP_MISSION_GET_STAGE: 'UP_MISSION_GET_STAGE',
  UP_MISSION_GET_INFOS: 'UP_MISSION_GET_INFOS',
  MISSION_UPDATE_INFO: 'MISSION_UPDATE_INFO',
  VIEW_MISSION: 'VIEW_MISSION',
}